<svg [ngClass]="class" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_16381_8017)">
    <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill="#372121"/>
  </g>
  <defs>
    <clipPath id="clip0_16381_8017">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>